import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {AuthenticationService} from '../../security/authentication.service';
import * as CryptoJS from 'crypto-js';
import * as moment from 'moment';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {ApiFactoryService} from '../../shared/services/api-factory.service';
import {ShareddataService} from '../../shared/services/shareddata.service';
import {AbstractBffApi, KeystringValueInterface, NewsInterface, NotLoggedinfoInterface} from '../../models/sharedinterface';
import {GlobalsService} from '../../shared/services/globals.service';
import {I18nService} from '../../shared/services/i18n.service';
import {DOCUMENT, Location} from '@angular/common';


@Component({
  selector: 'app-mainview',
  templateUrl: './mainview.component.html',
  styleUrls: ['./mainview.component.scss']
})
export class MainviewComponent implements OnInit {

  @ViewChild('main') mainContainer;
  @ViewChild('adminContent') adminContent;

  orderListOpened = false;
  helpSidebarOpened = false;
  helpId: number;

  loginForm: UntypedFormGroup;

  submittedLoginForm = false;
  isAuthenticating = false;

  isloggedin: boolean;
  loginError: string;

  bffapi: AbstractBffApi;

  siteinfo: NotLoggedinfoInterface;

  backgroundstyle: string; // Image url or hex code rgb color

  currentlanguage: KeystringValueInterface;

  currentNews: NewsInterface[];

  isNeutralBackground = false;

  isReady: boolean;

  constructor(
    private authservice: AuthenticationService,
    private fb: UntypedFormBuilder,
    private apifactory: ApiFactoryService,
    public router: Router,
    private shareddata: ShareddataService,
    private location: Location,
    private route: ActivatedRoute,
    private globalsservice: GlobalsService,
    public i18n: I18nService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.bffapi = this.apifactory.createBffApi();
    this.loginForm = new UntypedFormGroup({});
    this.submittedLoginForm = false;

    this.backgroundstyle = '#ffffff';
    this.currentNews = [];

    this.authservice.isloggedin$.subscribe((data) => {
      this.isloggedin = data;
    });
    this.shareddata.currentlanguage$.subscribe((data) => {
      this.currentlanguage = data;
    });
    this.shareddata.backgroundstyle$.subscribe((data) => {
      this.backgroundstyle = data;
    });

    this.route.fragment.subscribe((fragment: string) => {
      if (fragment && fragment.indexOf('help') !== -1) {
        const [, helpId] = fragment.split('-');
        this.helpSidebarOpened = true;
        this.helpId = helpId ? parseInt(helpId, 0) : undefined;
        // remove hash in url
        this.router.navigate([this.location.path()]);
        // this.location.replaceState(this.location.path());
      }
    });
  }

  /**
   * TODO: Remove dirty fix to show Biel-Bienne message
   */
  isBielBienne() {
    return document.URL.toLowerCase().indexOf('biel-bienne') !== -1;
  }

  ngOnInit(): void {

    this.authservice.checkLocalSession();

    this.loginForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });

    if (!this.isloggedin) {
      const query = this.bffapi.getsiteinfo();
      query.subscribe((data) => {
        console.log("getsiteinfo");
        console.log(data);
        this.siteinfo = data.results;
        this.backgroundstyle = 'url(' + this.siteinfo.backgrounduri + ')';
        this.shareddata.setMandanttitle(this.siteinfo.mandanttitle);
        this.isReady = true;
      });
    } else {
      // Loads private bundles
      this.i18n.getI18nBundle('orders').subscribe();
    } // if

    // listen to the routes to adapt main component for admin portal
    this.router.events.forEach((event) => {
      const currentUrl = this.router.url;
      if (event instanceof NavigationEnd) {

        this.isNeutralBackground = currentUrl.includes('/admin') || currentUrl.includes('/orders') || currentUrl.includes('/profil');
        // Closes order list on navigate events
        // this.orderListOpened = false;
      }
    });

    this.isNeutralBackground = this.router.url.includes('/admin') || this.router.url.includes('/orders') || this.router.url.includes('/profil');
  }

  toggleSidebar() {
    this.helpSidebarOpened = !this.helpSidebarOpened;
  }

  closeHelpSidebar() {
    this.helpSidebarOpened = false;
  }

  toggleOrderlist() {
    this.orderListOpened = !this.orderListOpened;
  }

  initToken(token) {
    if (token) {
      // @todo verify here if token is still valid
      const sessionDuration = 3600; // 1h duration by default
      const expiresAt = moment().add(sessionDuration, 'second');
      const stringify_expire = JSON.stringify(expiresAt.valueOf());

      localStorage.setItem('portal2020_token', token);
      localStorage.setItem('portal2020_expiration', stringify_expire);
    } // if
  } // initToken

  // convenience getter for easy access to form fields
  get f() {
    return this.loginForm.controls;
  }


  onLoginFormSubmit() {
    this.submittedLoginForm = true;
    this.isAuthenticating = false;
    this.orderListOpened = false;
    this.loginError = '';

    if (this.loginForm.valid && !this.isAuthenticating) {

      this.isAuthenticating = true;

      const formvalue = this.loginForm.value;

      const username = formvalue.username;
      const password = CryptoJS.MD5(formvalue.password).toString();
      const password2 = formvalue.password;

      const credential = username
        + this.globalsservice.getCredentialSeparator()
        + password
        + this.globalsservice.getCredentialSeparator()
        + password2;
      const encryptedWord = CryptoJS.enc.Utf8.parse(credential); // encryptedWord Array object
      const encryptedCredential = CryptoJS.enc.Base64.stringify(encryptedWord);

      const query = this.bffapi.login(encryptedCredential);
      query.subscribe((data) => {
          const token = data.results;
          this.initToken(token);
          this.authservice.setLoggedin(true);
          this.isAuthenticating = false;

          // Loads private bundles
          this.i18n.getI18nBundle('orders').subscribe();
          this.i18n.getI18nBundle('help').subscribe();

          this.bffapi.getLngUserPreference()
            .subscribe((returnLng) => {
              const lngpref = returnLng.results;

              this.shareddata.setCurrentlanguage(lngpref);
              // this.lngservice.changeLanguage(lngpref);

              // Reinit login error
              this.loginError = '';
            });
        },
        error => {
          if (error.status === 404) {// token not found - wrong credentials - user not found
            this.loginError = 'Wrong login or password.';
          } else if (error.status === 0) {// Unknown error - service not responding
            this.loginError = 'Network error. Please try again later.';
          } else if (error.status === 400) {// Bad request - Unauthorized
            this.loginError = 'Not authorized to access this portal.';
          } else if (error.status === 401) {// Account blocked
            this.loginError = 'This account is temporary blocked.';
          } else if (error.status === 403) {// Get info from the backedn
            this.loginError = error.error.message;
          }

          this.isAuthenticating = false;
        });

    } else {
      // Form validation failed
      if (this.loginForm.controls.username.errors && !this.loginForm.controls.password.errors) {
        this.loginError = 'Please enter your login.';
      } else if (this.loginForm.controls.password.errors && !this.loginForm.controls.username.errors) {
        this.loginError = 'Please enter your password.';
      } else {
        this.loginError = 'Please enter your credentials.';
      }
    } // if

  } // onLoginFormSubmit

  isMaintenanteMode() {
    if (this.siteinfo && this.siteinfo.maintenance_mode) {
      if (this.siteinfo.maintenance_mode.hasOwnProperty('maintenance_activ')) {
        if (this.siteinfo.maintenance_mode.maintenance_activ === 1) {
          return true;
        }
      }
    } // if
    return false;
  }

  onHeaderReady() {
    this.isReady = true;
  }
}
